import T from 'i18n-react'

import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
} from 'redux-saga/effects'

import {
  get,
  getWithMeta,
  post,
  del
} from 'helpers/RequestUtil'

import {
  FETCH_WEEKLY_UPDATES,
  FETCH_REMAINING_WEEKLY_UPDATES,
  POST_WEEKLY_UPDATE,
  DELETE_WEEKLY_UPDATE
} from './constants'

import {
  fetchWeeklyUpdatesStart,
  fetchWeeklyUpdatesSuccess,
  fetchWeeklyUpdatesError,
  fetchRemainingWeeklyUpdatesStart,
  fetchRemainingWeeklyUpdatesSuccess,
  fetchRemainingWeeklyUpdatesError,
  postWeeklyUpdateStart,
  postWeeklyUpdateSuccess,
  postWeeklyUpdateError,
  resetNewWeeklyUpdate,
  updateTotalCount,
  deleteWeeklyUpdateStart,
  deleteWeeklyUpdateSuccess,
  deleteWeeklyUpdateError,
  decrementTotalCount,
  incrementTotalCount
} from './actions'

import {
  nameSelector
} from 'containers/User/Login/selectors'

import {
  removeRow,
  updateTables
} from 'containers/Entity/actions'

import {
  error as errorAction
} from 'containers/App/Notification/actions'


function* fetchWeeklyUpdates(action) {
  const { projectId, offset, limit } = action
  try {
    yield put(fetchWeeklyUpdatesStart())
    const data = yield call(
      getWithMeta,
      `/api/fulcrum/projects/${projectId}/weekly_updates?page%5Blimit%5D=${limit}&page%5Boffset%5D=${offset}`
    )
    // Add new data to entities and results
    yield put(updateTables(data.data))
    yield put(updateTotalCount(data.meta.totalCount))
    yield put(fetchWeeklyUpdatesSuccess())
  } catch(error) {
    console.log(error)
    yield put(errorAction(T.translate('project.weeklyUpdates.fetchError')))
    yield put(fetchWeeklyUpdatesError(error))
  }
}

function* watchFetchWeeklyUpdates(){
    yield takeEvery(FETCH_WEEKLY_UPDATES, fetchWeeklyUpdates)
}

function* fetchRemainingWeeklyUpdates(action) {
  const { projectId, offset, limit } = action
  try {
    yield put(fetchRemainingWeeklyUpdatesStart())
    const data = yield call(
      get,
      `/api/fulcrum/projects/${projectId}/weekly_updates?page%5Blimit%5D=${limit}&page%5Boffset%5D=${offset}`
    )
    // Add new data to entities and results
    yield put(updateTables(data))
    yield put(fetchRemainingWeeklyUpdatesSuccess())
  } catch(error) {
    console.log(error)
    yield put(errorAction(T.translate('project.weeklyUpdates.fetchError')))
    yield put(fetchRemainingWeeklyUpdatesError(error))
  }
}

function* watchFetchRemainingWeeklyUpdates(){
    yield takeEvery(FETCH_REMAINING_WEEKLY_UPDATES, fetchRemainingWeeklyUpdates)
}

function* formatData(data){
  data.result['project_weekly_update_views'] = data.result['project_weekly_updates']
  data.entities['project_weekly_update_views'] = data.entities['project_weekly_updates']
  const userName = yield select(nameSelector)
  data.entities['project_weekly_update_views'][Object.keys(data.entities['project_weekly_update_views'])].userName = userName
}

function* postWeeklyUpdate(action){
  try{
    const { params } = action
    yield put(postWeeklyUpdateStart())
    const data = yield call(
      post,
      'project_weekly_updates',
      params,
      '/api/fulcrum/project_weekly_updates'
    )
    yield call(formatData, data)
    yield put(updateTables(data))
    yield put(incrementTotalCount())
    yield put(resetNewWeeklyUpdate())
    yield put(postWeeklyUpdateSuccess())
  } catch(error) {
    yield put(errorAction(T.translate('project.weeklyUpdates.postError')))
    yield put(postWeeklyUpdateError(error))
    yield put(resetNewWeeklyUpdate())
  }
}

function* watchPostWeeklyUpdate(){
  yield takeEvery(POST_WEEKLY_UPDATE, postWeeklyUpdate)
}

function* deleteWeeklyUpdate(action){
  try{
    const { id } = action
    yield put(deleteWeeklyUpdateStart())
    yield call(
      del,
      `/api/fulcrum/project_weekly_updates/${id}`
    )
    yield put(removeRow('project_weekly_update_views', id))
    yield put(decrementTotalCount())
    yield put(deleteWeeklyUpdateSuccess())
  } catch(error) {
    yield put(errorAction(T.translate('project.weeklyUpdates.deleteError')))
    yield put(deleteWeeklyUpdateError(error))
  }
}

function* watchDeleteWeeklyUpdate(){
  yield takeEvery(DELETE_WEEKLY_UPDATE, deleteWeeklyUpdate)
}

function* loadSagas() {
  yield all([
    fork(watchFetchWeeklyUpdates),
    fork(watchFetchRemainingWeeklyUpdates),
    fork(watchPostWeeklyUpdate),
    fork(watchDeleteWeeklyUpdate)
  ])
}

export default loadSagas
